module.exports = __webpack_public_path__ + "img/P45-zh.caa3803c.png";